const DOM_SUBTREES_PRELOAD_LINKS = [
  '.header__nav-wrapper.desktop-navigation__container',
  '.mobile-navigation__container',
  'section.page-hero',
  '.scalable-content-section__links',
  '.ProductCell__Content',
  '.footer .footer-wrapper',
];

DOM_SUBTREES_PRELOAD_LINKS.forEach(selector =>
  Array.from(document.querySelectorAll(`${selector} a`)).forEach(link =>
    link.setAttribute('data-instant', '')
  )
);
